// components/AllAnswersView.js
import React, { Component } from "react";
import axios from "axios";
// We can reuse AnswerCard or create a simpler display row if preferred
import AnswerCard from "./AnswerCard"; // Assuming AnswerCard can display an answer adequately

const config = require("../config.json");

export default class AllAnswersView extends Component {
  state = {
    answers: [],
    loading: false,
    error: null,
    lastEvaluatedKey: null,
    allLoaded: false,
  };

  componentDidMount() {
    this.fetchAnswers(true);
  }

  fetchAnswers = async (reset = false) => {
    if (this.state.loading && !reset) return;

    this.setState({ loading: true, error: null });
    let currentLastKey = this.state.lastEvaluatedKey;
    if (reset) {
      this.setState({ answers: [], allLoaded: false });
      currentLastKey = null;
    }

    const params = {};
    if (!reset && currentLastKey) {
      params.lastEvaluatedKey = encodeURIComponent(
        JSON.stringify(currentLastKey)
      );
    }

    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/messageboard/answers`,
        { params }
      );
      const { items, lastEvaluatedKey: newLastEvaluatedKeyString } = res.data;

      let newLastKey = null;
      if (newLastEvaluatedKeyString) {
        try {
          newLastKey = JSON.parse(
            decodeURIComponent(newLastEvaluatedKeyString)
          );
        } catch (e) {
          console.error("Error parsing lastEvaluatedKey for all answers:", e);
        }
      }

      this.setState((prevState) => ({
        answers: reset ? items : [...prevState.answers, ...items],
        lastEvaluatedKey: newLastKey,
        allLoaded: !newLastKey,
        loading: false,
      }));
    } catch (err) {
      console.error("Error fetching all answers:", err);
      this.setState({
        loading: false,
        error: `Failed to fetch answers: ${
          err.response?.data?.message || err.message
        }`,
      });
    }
  };

  handleLoadMore = () => {
    if (!this.state.allLoaded && !this.state.loading) {
      this.fetchAnswers(false);
    }
  };

  renderAnswerItem = (answer) => {
    // Simplified display for the list, or use full AnswerCard
    // For now, reusing AnswerCard which expects questionTitle.
    // The listAllAnswers Lambda currently doesn't enrich with questionTitle.
    // This would require an extra step in that Lambda or a simpler display here.
    // Let's make a simpler display for this view for now.
    const formattedDate = answer.createdAt
      ? new Date(answer.createdAt).toLocaleDateString()
      : "N/A";
    return (
      <div key={answer.answerId} className="box mb-3">
        <p>
          <strong>Answer ID:</strong> {answer.answerId}
        </p>
        <p className="is-size-7 has-text-grey">
          To Question (Common ID: {answer.questionCommonId}, Lang:{" "}
          {answer.questionLanguageCode})
        </p>
        <p className="mt-2">{answer.answerText}</p>
        <p className="is-size-7 mt-1">
          By User: {answer.userId}{" "}
          {answer.username ? `(${answer.username})` : ""}
          on {formattedDate} - Upvotes: {answer.upvoteCount || 0}
        </p>
        {answer.companyId && (
          <p className="is-size-7">
            <span className="tag is-info is-light">
              Company: {answer.companyId}
            </span>
          </p>
        )}
      </div>
    );
  };

  render() {
    const { answers, loading, error, allLoaded } = this.state;

    return (
      <div className="box">
        <h2 className="title is-4">All Submitted Answers</h2>
        <p className="subtitle is-6">
          Shows all answers across all questions, newest first.
        </p>
        <hr />

        {error && (
          <div className="notification is-danger is-light">{error}</div>
        )}

        {answers.length === 0 && !loading && !error && (
          <p>No answers found, or all items have been loaded.</p>
        )}

        <div className="all-answers-list">
          {answers.map(this.renderAnswerItem)}
        </div>

        {loading && (
          <p className="has-text-centered mt-4">Loading answers...</p>
        )}

        {!loading && !allLoaded && answers.length > 0 && (
          <div className="has-text-centered mt-5">
            <button onClick={this.handleLoadMore} className="button is-link">
              Load More Answers
            </button>
          </div>
        )}
        {allLoaded && answers.length > 0 && (
          <p className="has-text-centered has-text-grey mt-4">
            All answers loaded.
          </p>
        )}
      </div>
    );
  }
}
